import axios, { AxiosError } from 'axios';
import {
  BFF_ERROR_CODE_TYPES,
  BFF_ERROR_MESSAGES,
  errors
} from '@/constants/errors';
import GlobalAlert from '@/components/GlobalAlert';
import { FailureBffResponseDTO } from '@/@types/common';

//error boundary는 나중에...
export const getErrorMessage = (error: unknown) => {
  let errorMessage = '예상치 못한 에러가 발생하였습니다.';
  if (axios.isAxiosError(error)) {
    errorMessage = handleAxiosError(error);
  } else if (error instanceof Error) {
    errorMessage = error.message;
  }
  return errorMessage;
};

export const handleAxiosError = (error: AxiosError) => {
  const networkError = error.message === 'Network Error';
  const noExistApi = error.response?.data?.code === 'NotFoundException';
  if (networkError) return 'NetworkError';
  if (noExistApi) return 'NotFoundException';
  const errorMessage =
    errors[error.response?.data?.code] || error.response?.data?.message;
  return errorMessage;
};

export function getErrorCodeFromResponse(response: FailureBffResponseDTO) {
  try {
    const { errors } = response;
    const [error] = errors;
    const { extensions } = error;

    return getErrorCode(extensions?.code);
  } catch (e) {
    return getErrorCode();
  }
}

export function getErrorMessageFromResponse(response: FailureBffResponseDTO) {
  try {
    return response?.errors?.[0]?.message;
  } catch (e) {
    return '';
  }
}

const getErrorCode = (errorCode?: BFF_ERROR_CODE_TYPES) => {
  if (!errorCode) return BFF_ERROR_CODE_TYPES.Default;
  if (!BFF_ERROR_CODE_TYPES[errorCode]) return BFF_ERROR_CODE_TYPES.Default;

  return BFF_ERROR_CODE_TYPES[errorCode];
};

const getErrorText = (errorCode?: BFF_ERROR_CODE_TYPES) => {
  if (!errorCode) return BFF_ERROR_MESSAGES.Default;
  if (!BFF_ERROR_MESSAGES[errorCode]) return BFF_ERROR_MESSAGES.Default;

  return BFF_ERROR_MESSAGES[errorCode];
};

export const showErrorModal = (errorCode?: BFF_ERROR_CODE_TYPES) => {
  const errorText = getErrorText(errorCode);

  const isModalOpened = GlobalAlert.getVisible();

  if (!isModalOpened) {
    GlobalAlert.show({
      title: '',
      body: errorText
    });
  }
};
